( function( $, document, window ) {
	'use strict';

	$( function() {
		$( '.js-card-carousel' ).each( function( index, element ) {
			const $this = $( this );
			$this.addClass( 'card-carousel-instance-' + index );
			$this.next( '.carousel-controls' ).find( '.js-carousel-nav-prev' ).addClass( 'js-carousel-nav-prev-' + index );
			$this.next( '.carousel-controls' ).find( '.js-carousel-nav-next' ).addClass( 'js-carousel-nav-next-' + index );
			$this.next( '.carousel-controls' ).find( '.js-card-carousel-pagination' ).addClass( 'js-card-carousel-pagination-' + index );

			const cardSwiper = new Swiper( '.card-carousel-instance-' + index, {
				direction: 'horizontal',
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				spaceBetween: 20,
				loop: false,

				pagination: {
					el: '.js-card-carousel-pagination-' + index,
					type: 'progressbar',
				},

				navigation: {
					nextEl: '.js-carousel-nav-next-' + index,
					prevEl: '.js-carousel-nav-prev-' + index,
				},
			} );
		} );
	} );
} )( jQuery, document, window );
